<template>
  <el-form :model="form" label-width="95px" :disabled="mode === 'view'">
    <el-form-item label="数据来源">
      <el-select
        v-model="form.dataSource"
        placeholder="请选择栏目"
        filterable
        @change="sourceChange"
      >
        <el-option
          v-for="item in columnData"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="图片展示">
      <el-select v-model="form.imageFit" placeholder="请选择" filterable @change="selectChange">
        <el-option
          v-for="item in imageFitType"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="显示名称" v-if="form.showTitle">
      <el-input
        v-model="form.title"
        placeholder="显示名称"
        @input="selectChange"
        maxlength="20"
        clearable
      />
    </el-form-item>
    <el-form-item label="显示时间">
      <el-checkbox v-model="form.showDate" @change="selectChange"></el-checkbox>
    </el-form-item>
    <el-form-item label="显示分页">
      <el-checkbox v-model="form.showPagination" @change="selectChange"></el-checkbox>
    </el-form-item>
    <el-form-item label="显示栏目名称">
      <el-checkbox v-model="form.showTitle" @change="selectChange"></el-checkbox>
    </el-form-item>
    <el-form-item label="显示更多">
      <el-checkbox v-model="form.showMore" @change="selectChange"></el-checkbox>
    </el-form-item>
    <el-form-item label="展示行数">
      <el-input-number
        v-model="form.row"
        :min="1"
        @change="selectChange"
        controls-position="right"
        class="w-full"
      />
    </el-form-item>
    <el-form-item label="每行展示条数">
      <el-input-number
        v-model="form.col"
        :min="1"
        @change="selectChange"
        controls-position="right"
        class="w-full"
      />
    </el-form-item>
    <layoutConfig
      :config="config"
      :layoutWidth="layoutWidth"
      :layout="layout"
      @layoutChange="layoutChange"
    />
  </el-form>
</template>

<script>
import { ColumApi } from '@wiz-api/workbench'
import { treeToOneArray } from '@/assets/js/Common'
import layoutConfig from './LayoutConfig'
import { imageFitType } from '../../js/config'

const columnApi = new ColumApi()
export default {
  props: ['configData', 'layoutData', 'mode', 'layoutWidth', 'layout'],
  components: {
    layoutConfig,
  },
  data() {
    return {
      form: {
        dataSource: '', // 数据来源
        showDate: true, // 显示时间
        showPagination: true, // 显示分页
        showTitle: true, // 显示栏目名称
        showMore: true, // 显示更多
        row: 1, // 展示行数
        col: 1, // 每行展示条数
        imageFit: 'fill', // 图片填充方式
        title: '', // 显示栏目名称
      },
      config: {
        w: 10,
        h: 10,
      },
      columnData: [],
      imageFitType,
    }
  },
  watch: {
    configData: {
      deep: true,
      immediate: true,
      handler(val) {
        this.form = this.$options.data().form
        if (!_.isEmpty(val)) {
          _.assign(this.form, val)
        } else {
          this.selectChange()
        }
      },
    },
    layoutData: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!_.isEmpty(val)) {
          this.config = _.pick(this.layoutData, ['w', 'h', 'type', 'x', 'y', 'i'])
        }
      },
    },
  },
  methods: {
    async getColumnData() {
      const [err, res] = await columnApi.tree(0)
      if (!err) {
        const data = treeToOneArray(res, 'child')
        this.columnData = _.filter(data, (item) => {
          return item.type === this.config.type
        })
      }
    },
    sourceChange() {
      this.form.title = _.find(this.columnData, { id: this.form.dataSource }).name
      this.selectChange()
    },
    selectChange() {
      this.$emit('configChange', this.form)
    },
    layoutChange(val) {
      this.config = _.cloneDeep(val)
      this.$emit('layoutChange', val)
    },
  },
  created() {
    this.getColumnData()
  },
}
</script>

<style></style>
